// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"7d436d7d","40":"7f120bac","73":"45bbd12c","162":"75677b65","261":"a87647a6","408":"ae9287ea","607":"421cefa5","627":"e16b2dde","771":"7c649649"}[chunkId] + ".chunk.css";
};